var map = {
	"./account/auth.js": 27045,
	"./admin/access/campus-access.js": 37252,
	"./admin/access/delivery-unit-access.js": 95202,
	"./admin/document/access-level/access-level.js": 15238,
	"./admin/document/category/category.js": 12108,
	"./admin/document/category/group.js": 7701,
	"./admin/document/tag/tag.js": 98554,
	"./admin/setting/campus/campus.js": 7415,
	"./admin/setting/delivery-unit/deliveryUnit.js": 59026,
	"./admin/setting/office/office.js": 36429,
	"./admin/user/approver.js": 4490,
	"./admin/user/userAdmin.js": 38133,
	"./ai-chat/chat.js": 90757,
	"./ai-chat/file-view.js": 41575,
	"./ai-file-manager/ai-doc-upload.js": 69220,
	"./ai-file-manager/smart-upload.js": 38352,
	"./custom.js": 39692,
	"./dashboard/public/category.js": 14978,
	"./dashboard/public/recent.js": 16241,
	"./dashboard/public/search.js": 12114,
	"./file-location-manager/breadcrumb.js": 68331,
	"./file-location-manager/file/file.js": 3613,
	"./file-location-manager/location.js": 28785,
	"./file-location-manager/moveLocation.js": 70379,
	"./file-location-manager/set-location/setLocation.js": 57986,
	"./file-manager/breadcrumb.js": 45447,
	"./file-manager/breadcrumbV2.js": 43439,
	"./file-manager/file/categoryFile.js": 19761,
	"./file-manager/file/file.js": 51001,
	"./file-manager/file/moveFile.js": 36984,
	"./file-manager/file/pinFile.js": 83266,
	"./file-manager/file/share.js": 22432,
	"./file-manager/file/sortFile.js": 27381,
	"./file-manager/file/sortPinFile.js": 13822,
	"./file-manager/file/sortPublicFile.js": 38856,
	"./file-manager/file/trashFile.js": 19371,
	"./file-manager/folder-file/folder-file.js": 66035,
	"./file-manager/folder/folder.js": 82005,
	"./file-manager/folder/moveFolder.js": 93544,
	"./file-manager/folder/movePinFolder.js": 24489,
	"./file-manager/folder/pinFolder.js": 97674,
	"./file-manager/folder/simpleFolder.js": 42107,
	"./file-manager/folder/sortFolder.js": 99301,
	"./file-manager/folder/sortPinFolder.js": 79610,
	"./file-manager/folder/trashFolder.js": 40987,
	"./file-manager/pin/sortFile.js": 36164,
	"./file-manager/pin/sortFolder.js": 91082,
	"./file-manager/search/advancedSearch.js": 5007,
	"./file-posting/admin/approved.js": 28726,
	"./file-posting/admin/pending.js": 78062,
	"./file-posting/du/pending.js": 19818,
	"./file-posting/du/posted.js": 84074,
	"./file-posting/du/returned.js": 41010,
	"./file-posting/duPublic.js": 72511,
	"./file-posting/posting.js": 14499,
	"./notification.js": 40952,
	"./pool/pool-files-v2/file.js": 44110,
	"./pool/pool-files-v2/my-folder.js": 28127,
	"./pool/pool-files-v2/posted-files.js": 22453,
	"./pool/post-file.js": 64117,
	"./pool/post.js": 36290,
	"./pool/user.js": 65707,
	"./profile/profile.js": 37076,
	"./report/location.js": 63475
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 70634;